<p-dialog #dialogRoot [(visible)]="dialogFormVisible"
          [modal]="true" [styleClass]="'p-fluid cc-dialog-form '+dialogClass "
          [closeOnEscape]="true" (onShow)="onShow();
          reloadFieldValueMap(); validateForm();"
          (onHide)="dialogFormVisibleChange.emit(false)"
          [resizable]="false"
          appendTo="body" position="top">

  <!--  [header]="dialogFormTitle+recordName"-->
  <ng-template pTemplate="header">
    <span class="p-dialog-title ng-tns-c4292766971-65 ng-star-inserted header-left"
          id="pn_id_49-label">{{ dialogFormTitle + recordName }}
      <ng-content select="[header-left]"></ng-content>
    </span>

    <span class="header-right"><ng-content select="[header-right]"></ng-content></span>
  </ng-template>

  <!--          (visibleChange)="dialogFormVisibleChange.emit(dialogFormVisible)"-->
  <ng-template pTemplate="content">
    <form>
      <app-cc-form #ccForm [transPartKey]="transPartKey"
                   [loading]="loading" [submitted]="submitted"
                   [formConfig]="formConfig" [(formRecord)]="formRecord"
                   [loadingProgressValue]="loadingProgressValue"
                   [globalErrorMessage]="globalErrorMessage"
                   [globalInfoMessage]="globalInfoMessage"
                   (formRecordChange)="formRecordChange.emit($event); reloadFieldValueMap(); validateForm()"
      ></app-cc-form>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <span class="footer-left"><ng-content select="[footer-left]"></ng-content></span>
    <span class="footer-right">
      <ng-content select="[footer-right]"></ng-content>
      <button pButton type="button" (click)="closeDialog()" [disabled]="this.loading || this.loadingProgressValue < 100"
              [label]="cancelButtonLabel?cancelButtonLabel:'common.dialog.cancel' | translate"
              class="p-button-warning p-button-sm"></button>
      <button pButton type="button" (click)="submit()"
              [disabled]="this.loading || this.loadingProgressValue < 100 || disableSubmitButton || !formValid"
              [label]="submitButtonLabel?submitButtonLabel:'common.dialog.save' | translate"
              class="p-button-success p-button-sm"></button>
    </span>
  </ng-template>
</p-dialog>
